/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B000151 納入先照会
 */
import { Column, Query } from "@material-table/core";
import {
  B000150Tokui,
  B000151Find,
  B000151FindRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { B000ShokaKbn, getSCode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B000150 } from "pages";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { mapIds } from "services";
import { focusState, SDialogContext, useFocus } from "states";

// TODO: エラーの文章未確定

// 呼び出し時のプロパティ
type Props = Partial<{
  tokuiCd: string;
  tokuishitenCd: string;
  // 取引終了日付
  torihikishuryoYmd: string;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  shokaKbn: SCode;
  nonyuCdFrom: string;
  nonyushitenCdFrom: string;
  nonyuCdTo: string;
  nonyushitenCdTo: string;
  name: string;
  torihikishuryoYmd: string;
}>;

// テーブル定義
type Data = Partial<{
  gyoNo: number;
  nonyuCd: string;
  nonyushitenCd: string;
  tokuiNm1: string;
  tokuiNm2: string;
  tokuiKana: string;
  shainCd: string;
  tokuiKbn: number;
  tokuiNmr: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shokuchiKbn: number;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  seikyuKbn: number;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeKbn: number;
  urikakeCd: string;
  urikakeshitenCd: string;
  nonyuKbn: number;
  urikakeshainCd: string;
  tankaKakeritsu: number;
  tokuibunCd1: string;
  tokuibunCd2: string;
  tokuibunCd3: string;
  tokuibunCd4: string;
  tokuibunCd5: string;
  zeiKbn: string;
  zeimarumeKbn: number;
  zeihasuichi: number;
  kinmarumeKbn: number;
  kinhasuichi: number;
  shokaKbn: number;
  denpyoshubetsuCd: string;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  ritsu: string;
  bunrui: string;
  torihikisakiCd: string;
  hyakatenCd: string;
  shutsuryokushohinCd: number;
  jodaihyojiKbn: number;
  unsogaishaCd: string;
  shimeD: number;
  kaishuyoteiM: number;
  kaishuyoteiD: number;
  seikyushoKbn: number;
  seikyushokeishikiKbn: string;
  seikyushosaibanKbn: number;
  seikyushoNo: number;
  kaishuKbn: number;
  itakusokoCd: string;
  shatenCd: string;
  kigyoCd: string;
  tenpoCd: string;
  tankamarumeKbn: number;
  tankahasuichi: number;
  kyakusakinoKbn: number;
  sakujoyoteiKbn: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  shokaKbn: getSCode(B000ShokaKbn, "0"),
  nonyuCdFrom: "",
  nonyushitenCdFrom: "",
  nonyuCdTo: "",
  nonyushitenCdTo: "",
  name: "",
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "2rem", align: "right" },
  { field: "nonyuCd", title: "納入先コード", width: "6rem" },
  { field: "nonyushitenCd", title: "", width: "4rem" },
  { field: "tokuiNm1", title: "納入先名", width: "6rem" },
  { field: "tokuiNm2", title: "", width: "4rem" },
  { field: "tokuiKana", title: "納入先カナ", width: "10rem" },
  { field: "tokuiCd", hidden: true },
  { field: "tokuishitenCd", hidden: true },
  { field: "hyojunnonyuKbn", hidden: true },
  { field: "shainCd", hidden: true },
  { field: "tokuiKbn", hidden: true },
  { field: "tokuiNmr", hidden: true },
  { field: "postCd", hidden: true },
  { field: "address1", hidden: true },
  { field: "address2", hidden: true },
  { field: "telNo", hidden: true },
  { field: "faxNo", hidden: true },
  { field: "shokuchiKbn", hidden: true },
  { field: "torihikikaishiYmd", hidden: true },
  { field: "torihikishuryoYmd", hidden: true },
  { field: "seikyuKbn", hidden: true },
  { field: "seikyuCd", hidden: true },
  { field: "seikyushitenCd", hidden: true },
  { field: "urikakeKbn", hidden: true },
  { field: "urikakeCd", hidden: true },
  { field: "urikakeshitenCd", hidden: true },
  { field: "nonyuKbn", hidden: true },
  { field: "urikakeshainCd", hidden: true },
  { field: "tankaKakeritsu", hidden: true },
  { field: "tokuibunCd1", hidden: true },
  { field: "tokuibunCd2", hidden: true },
  { field: "tokuibunCd3", hidden: true },
  { field: "tokuibunCd4", hidden: true },
  { field: "tokuibunCd5", hidden: true },
  { field: "zeiKbn", hidden: true },
  { field: "zeimarumeKbn", hidden: true },
  { field: "zeihasuichi", hidden: true },
  { field: "kinmarumeKbn", hidden: true },
  { field: "kinhasuichi", hidden: true },
  { field: "shokaKbn", hidden: true },
  { field: "denpyoshubetsuCd", hidden: true },
  { field: "denpyoKbn", hidden: true },
  { field: "tenpudenpyoCd", hidden: true },
  { field: "ritsu", hidden: true },
  { field: "bunrui", hidden: true },
  { field: "torihikisakiCd", hidden: true },
  { field: "hyakatenCd", hidden: true },
  { field: "shutsuryokushohinCd", hidden: true },
  { field: "jodaihyojiKbn", hidden: true },
  { field: "unsogaishaCd", hidden: true },
  { field: "shimeD", hidden: true },
  { field: "kaishuyoteiM", hidden: true },
  { field: "kaishuyoteiD", hidden: true },
  { field: "seikyushoKbn", hidden: true },
  { field: "seikyushokeishikiKbn", hidden: true },
  { field: "seikyushosaibanKbn", hidden: true },
  { field: "seikyushoNo", hidden: true },
  { field: "kaishuKbn", hidden: true },
  { field: "itakusokoCd", hidden: true },
  { field: "shatenCd", hidden: true },
  { field: "kigyoCd", hidden: true },
  { field: "tenpoCd", hidden: true },
  { field: "tankamarumeKbn", hidden: true },
  { field: "tankahasuichi", hidden: true },
  { field: "kyakusakinoKbn", hidden: true },
  { field: "sakujoyoteiKbn", hidden: true },
];

const focusId = "B000151";

export const B000151 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするRef
  const isDefaultPage = useRef(false);
  // ダイアログで処理を行う関数
  const handleSubmit = useContext(SDialogContext);
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    (async () => {
      // 取引終了日
      if (props.torihikishuryoYmd) {
        methods.setValue("torihikishuryoYmd", props.torihikishuryoYmd);
      }

      // 処理詳細１
      // 呼び出し元で得意先コード及び得意先支店コードが設定されている場合
      if (props.tokuiCd && props.tokuishitenCd) {
        methods.setValue("tokuiCd", props.tokuiCd);
        methods.setValue("tokuishitenCd", props.tokuishitenCd);

        // 呼び出し元で設定された値を設定し、処理詳細 2 を呼び出す。
        // 処理詳細 2
        //B000150/get を実行し、得意先区分が「1:なる」であった場合、返却値を tokuiNm,shokaKbn に設定する。
        // API呼び出し
        await B000150Tokui(methods, navigate, setMsg);
        focus(4);
      }
      // 得意先コード及び得意先支店コードが両方設定されていない場合
      else {
        // 初回フォーカス先
        focus(1);
      }
    })();
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    handleSubmit(data);
  };

  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 納入先コード、納入先支店コードの検索条件の組み合わせ
      // 1.納入先コード(From)のみ入力されている場合
      // そのまま検索できる

      // 2.納入先支店コード(From)のみ入力されている場合
      // 納入先コード(From)の入力を必須とする

      // 納入先支店コード(From)が入力されている場合
      if (fields.nonyushitenCdFrom !== "") {
        // 納入先コード(From)が入力されていない場合
        if (fields.nonyuCdFrom === "") {
          setMsg(
            "納入先支店コードのみの入力はできません。納入先コードを入力して下さい"
          );
        }
      }

      // 3.納入先コード(To)もしくは納入先支店コード(To)のみ入力されている場合
      // 納入先コード(From)と納入先支店コード(From)、納入先コード(To)と納入先支店コード(To)の入力を必須とする

      // 納入先コード(From)か納入先支店コード(From)が入力されていない場合
      if (fields.nonyuCdFrom === "" || fields.nonyushitenCdFrom === "") {
        // 納入先コード(To)か納入先支店コード(To)が入力されている場合
        if (fields.nonyuCdTo !== "" || fields.nonyushitenCdTo !== "") {
          setMsg("納入先コードか納入先支店コードの開始を入力して下さい");
        }
      }

      // 検索パラメータを作成する。
      const param: B000151FindRequest = {
        tokuiCd: fields.tokuiCd,
        tokuishitenCd: fields.tokuishitenCd,
        nonyuCdFrom: fields.nonyuCdFrom,
        nonyushitenCdFrom: fields.nonyushitenCdFrom,
        nonyuCdTo: fields.nonyuCdTo,
        nonyushitenCdTo: fields.nonyushitenCdTo,
        shokaKbn: fields.shokaKbn?.value,
        name: fields.name,
        torihikishuryoYmd: fields.torihikishuryoYmd,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        // ["出力項目名,順番(asc/desc", ...]
        sort: ["nonyuCd,asc"],
      };

      // API呼び出し
      B000151Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="納入先照会"
        gridTemplateColumns="6rem 8rem 6rem 1rem 8rem 6rem 6rem 9rem"
      >
        <SLabel>得意先コード</SLabel>
        <SNumberField
          name="tokuiCd"
          code
          size={6}
          {...register(1)}
          onBlur={() => B000150Tokui(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCd"
          code
          size={4}
          onBlur={() => B000150Tokui(methods, navigate, setMsg)}
          {...register(2)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCd", data.tokuiCd);
            methods.setValue("tokuishitenCd", data.tokuishitenCd);
            methods.setValue("tokuiNm", data.tokuiNm1);
          }}
        />
        <STextField name="tokuiNm" size={40} disabled gridColumn="span 3" />
        <SLabel>消化区分</SLabel>
        <SCodeSelect name="shokaKbn" options={B000ShokaKbn} {...register(3)} />
        <SLabel gridColumn="1">納入先コード</SLabel>
        <SNumberField name="nonyuCdFrom" code size={6} {...register(4)} />
        <SNumberField name="nonyushitenCdFrom" code size={4} {...register(5)} />
        <SText>～</SText>
        <SNumberField name="nonyuCdTo" code size={6} {...register(6)} />
        <SNumberField name="nonyushitenCdTo" code size={4} {...register(7)} />
        <SLabel gridColumn="1">納入先名</SLabel>
        <STextField
          name="name"
          size={40}
          gridColumn="span 5"
          {...register(8)}
        />
        <SNormalButton
          label={labels.buttons.search}
          onClick={handleClickSearchButton}
          gridRow={4}
          gridColumn={8}
          {...register(9)}
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
        />
      </SFrame>
    </FormProvider>
  );
};
